import { serviceMixin } from "@/mixins/serviceMixin";
export const mediaMixin = {
  mixins: [serviceMixin ],
  data() {
    return {
      fotos: [],
      isBusy: false,
    };
  },
  props: ["url", "uploadfolder"],
  methods: {
    removePublicIc(public_id) {
      for (var f in this.fotos)
        if (this.fotos[f].public_id == public_id) this.fotos.splice(f, 1);
    },
    deleteMedia(public_id) {
      var vm = this;
      this.$http.delete(this.url, { data: { public_ids: [ public_id ] } })
        .then(function(response) {
          console.dir(response.data);
          for (var file in response.data.result.deleted)
            vm.removePublicIc(file);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getMedia(url) {
      var vm = this;
      this.isBusy = true;
      console.log(this.url);
      this.get(url || this.url)
        .then(function(response) {
          console.dir(response.data);
          vm.fotos = response.data.fotos || [];
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(function() {
          vm.isBusy = false;
        });
    }
  },
  
};
